/* eslint-disable */
import React from 'react';

export type MisconceptionCardIconRender = (active: boolean) => React.ReactNode;

export const PSA_CARD_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51 63V57C51 53.8174 49.7357 50.7652 47.4853 48.5147C45.2348 46.2643 42.1826 45 39 45H15C11.8174 45 8.76516 46.2643 6.51472 48.5147C4.26428 50.7652 3 53.8174 3 57V63M69 63V57C68.998 54.3412 68.1131 51.7583 66.4841 49.6569C64.8551 47.5556 62.5744 46.0547 60 45.39M48 9.39C50.5812 10.0509 52.8691 11.5521 54.5029 13.6569C56.1367 15.7618 57.0235 18.3505 57.0235 21.015C57.0235 23.6795 56.1367 26.2682 54.5029 28.3731C52.8691 30.4779 50.5812 31.9791 48 32.64M39 21C39 27.6274 33.6274 33 27 33C20.3726 33 15 27.6274 15 21C15 14.3726 20.3726 9 27 9C33.6274 9 39 14.3726 39 21Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.7199 23.28C50.3935 24.9518 51.7212 26.9369 52.627 29.1221C53.5329 31.3073 53.9991 33.6496 53.9991 36.015C53.9991 38.3805 53.5329 40.7228 52.627 42.908C51.7212 45.0931 50.3935 47.0783 48.7199 48.75M23.2799 48.72C21.6064 47.0483 20.2787 45.0631 19.3729 42.878C18.467 40.6928 18.0008 38.3505 18.0008 35.985C18.0008 33.6196 18.467 31.2773 19.3729 29.0921C20.2787 26.9069 21.6064 24.9218 23.2799 23.25M57.2099 14.79C62.8341 20.4159 65.9935 28.0451 65.9935 36C65.9935 43.955 62.8341 51.5842 57.2099 57.21M14.7899 57.21C9.16581 51.5842 6.00635 43.955 6.00635 36C6.00635 28.0451 9.16581 20.4159 14.7899 14.79M41.9999 36C41.9999 39.3137 39.3137 42 35.9999 42C32.6862 42 29.9999 39.3137 29.9999 36C29.9999 32.6863 32.6862 30 35.9999 30C39.3137 30 41.9999 32.6863 41.9999 36Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.9499 43.1701L35.9999 66.3901L4.04994 43.1701C3.62162 42.8551 3.3039 42.4127 3.14225 41.9062C2.98059 41.3997 2.98329 40.855 3.14994 40.3501L6.80994 29.0101L14.1299 6.48013C14.2009 6.29655 14.314 6.13216 14.4599 6.00013C14.6977 5.78299 15.008 5.6626 15.3299 5.6626C15.6519 5.6626 15.9622 5.78299 16.1999 6.00013C16.3541 6.14912 16.4677 6.33498 16.5299 6.54013L23.8499 29.0101H48.1499L55.4699 6.48013C55.5409 6.29655 55.654 6.13216 55.7999 6.00013C56.0377 5.78299 56.348 5.6626 56.6699 5.6626C56.9919 5.6626 57.3022 5.78299 57.5399 6.00013C57.6941 6.14912 57.8077 6.33498 57.8699 6.54013L65.1899 29.0701L68.9999 40.3501C69.1515 40.8706 69.1312 41.426 68.9421 41.9341C68.7529 42.4421 68.405 42.8755 67.9499 43.1701Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63 63L49.95 49.95M33 24V42M24 33H42M57 33C57 46.2548 46.2548 57 33 57C19.7452 57 9 46.2548 9 33C9 19.7452 19.7452 9 33 9C46.2548 9 57 19.7452 57 33Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

// export const FAKE_WEBSITE_CARD_ICONS: MisconceptionCardIconRender[] = [
//   // 电脑显示器
//   (active: boolean) => (
//     <svg
//       width="72"
//       height="72"
//       viewBox="0 0 72 72"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <rect
//         x="6"
//         y="12"
//         width="60"
//         height="40"
//         rx="4"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M6 22H66"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M30 52V58"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M22 58H42"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ),
//   // 添加用户
//   (active: boolean) => (
//     <svg
//       width="72"
//       height="72"
//       viewBox="0 0 72 72"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <circle
//         cx="24"
//         cy="20"
//         r="10"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M8 58C8 46.9543 16.9543 38 28 38"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M48 18V34"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M40 26H56"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ),
//   // 播放箭头
//   (active: boolean) => (
//     <svg
//       width="72"
//       height="72"
//       viewBox="0 0 72 72"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M16 12L60 36L16 60V12Z"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ),
//   // 显示器警告
//   (active: boolean) => (
//     <svg
//       width="72"
//       height="72"
//       viewBox="0 0 72 72"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <rect
//         x="10"
//         y="10"
//         width="52"
//         height="38"
//         rx="4"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M10 20H62"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M36 40L26 52H46L36 40Z"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ),
// ];

export const HCG_ICONS: MisconceptionCardIconRender[] = [
  // 文件
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 39C8 37.6739 8.52678 36.4021 9.46447 35.4645C10.4021 34.5268 11.6739 34 13 34H40M8 39C8 40.3261 8.52678 41.5979 9.46447 42.5355C10.4021 43.4732 11.6739 44 13 44H40V4H13C11.6739 4 10.4021 4.52678 9.46447 5.46447C8.52678 6.40215 8 7.67392 8 9V39Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  //film
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 16C19.5817 16 16 19.5817 16 24C16 28.4183 19.5817 32 24 32C28.4183 32 32 28.4183 32 24C32 19.5817 28.4183 16 24 16ZM24 16H42.34M7.9 12.12L17.08 28M21.76 43.88L30.92 28M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 信息
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.54 13.92L24 24.0201L41.46 13.92M24 44.16V24M42 32V16C41.9993 15.2986 41.8141 14.6097 41.4631 14.0024C41.112 13.3951 40.6075 12.8908 40 12.54L26 4.54005C25.3919 4.18898 24.7021 4.00415 24 4.00415C23.2979 4.00415 22.6081 4.18898 22 4.54005L8 12.54C7.39253 12.8908 6.88796 13.3951 6.53692 14.0024C6.18589 14.6097 6.00072 15.2986 6 16V32C6.00072 32.7015 6.18589 33.3904 6.53692 33.9977C6.88796 34.605 7.39253 35.1093 8 35.46L22 43.46C22.6081 43.8111 23.2979 43.9959 24 43.9959C24.7021 43.9959 25.3919 43.8111 26 43.46L40 35.46C40.6075 35.1093 41.112 34.605 41.4631 33.9977C41.8141 33.3904 41.9993 32.7015 42 32Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 图片
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 8H36C37.0609 8 38.0783 8.42143 38.8284 9.17157C39.5786 9.92172 40 10.9391 40 12V40C40 41.0609 39.5786 42.0783 38.8284 42.8284C38.0783 43.5786 37.0609 44 36 44H12C10.9391 44 9.92172 43.5786 9.17157 42.8284C8.42143 42.0783 8 41.0609 8 40V12C8 10.9391 8.42143 9.92172 9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8H16M18 4H30C31.1046 4 32 4.89543 32 6V10C32 11.1046 31.1046 12 30 12H18C16.8954 12 16 11.1046 16 10V6C16 4.89543 16.8954 4 18 4Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];
